import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, CardContent, Dialog, Grid, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { CountdownCmp } from "../countdown/Countdown";
import { NoticeCountdownCmp } from "../countdown/NoticeCountdown";
import { title } from "process";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalNoticeInfo({
  openModel,
  setSendConfirmation,
  setOpenVerifyModal,
  setSendNotification,
  setSendBody,
  canSendSms,
  titleNotice,
}: any) {
  const differenceLength = setSendNotification.length - setSendBody.length;
  let characterLength: any = 400;
  if (differenceLength > 200) {
    characterLength = 500;
  }
  let title;
  if (canSendSms != null && canSendSms != undefined) {
    if (canSendSms == true) {
      title = "پیامک";
    } else {
      title = "اطلاعیه";
    }
  }

  const [open, setOpen] = React.useState<boolean>(openModel);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSendConfirmation(false);
    setOpenVerifyModal(false);
  };
  React.useEffect(() => {
    setOpen(openModel);
  }, [openModel]);

  function handleOnCompletedClick() {
    setSendConfirmation(true);
    setOpen(false);
    setOpenVerifyModal(false);
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <>
          <Grid>
            <Box
              sx={style}
              style={{ borderRadius: "6px", padding: "2px 40px 40px 40px" }}
              className="ModalCmp  "
            >
              <Grid
                item
                xs={12}
                className="classCenter"
                style={{ paddingTop: "5vh" }}
              >
                <span className="textFont16 colorDefaultFont">
                  آیا از ارسال این {title} برای پذیرندگان اطمینان دارید؟
                </span>
                <br />
                <span className="textFont16 colorDefaultFont">پس از</span>
                <span className="textFont15 fontWeight colorRed">
                  {" "}
                  اتمام زمان{" "}
                </span>
                <span className="textFont16 colorDefaultFont">
                  تعیین شده در صورت{" "}
                </span>
                <span className="textFont15 fontWeight colorRed">تایید، </span>
                <span className="textFont16 colorDefaultFont">
                  {title} ارسال خواهد شد.{" "}
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                // className="classCenter"
                style={{ paddingTop: "7vh" }}
              >
                <span
                  className="textFont12 colorDefaultFont fontWeight"
                  style={{
                    marginTop: "-20px",
                    marginRight: "20px",
                    paddingRight: "10px",
                    paddingLeft: "10px",
                    display: "flex",
                    alignItems: " center",
                    width: "fit-content",
                    transform: "translateY(-25%)",
                    backgroundColor: "white",
                  }}
                >
                  متن {title}
                </span>
                <Box
                  sx={{
                    p: 3,
                    border: "1px solid #DAE0E4",
                    borderRadius: "5px",
                    marginTop: "-14px",
                  }}
                >
                  <div>
                    {canSendSms ? (
                      titleNotice
                    ) : setSendBody?.length > 400 ? (
                      <span>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: setSendNotification?.slice(
                              0,
                              characterLength
                            ),
                          }}
                          className="my-4"
                        ></p>
                        ...
                      </span>
                    ) : (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: setSendNotification,
                        }}
                        className="my-4"
                      ></p>
                    )
                    // &&
                    // setSendBody?.length > 400 && "..."
                    }
                  </div>
                </Box>
              </Grid>
              <Grid container xs={12} style={{ paddingTop: "7vh" }}>
                <Grid item xs={6} style={{ paddingLeft: "1vh" }}>
                  <NoticeCountdownCmp
                    countDownValue={10000}
                    onCompletedClick={() => handleOnCompletedClick()}
                    btnName="تایید و ارسال"
                  />
                </Grid>
                <Grid item xs={6} style={{ paddingRight: "1vh" }}>
                  <Button
                    // type="submit"
                    fullWidth
                    className="btnForm colorEdit"
                    onClick={handleClose}
                  >
                    ویرایش {title}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </>
      </Modal>
    </div>
  );
}
